




















import { defineComponent } from "@vue/composition-api";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { BlockingStatus } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import MessageItemAttachmentAudio from "./MessageItemAttachmentAudio.vue";
import MessageMediaGallery from "./MessageMediaGallery.vue";

export default defineComponent({
  name: "MessageItemAttachment",
  components: { MessageMediaGallery, BaseIcon, MessageItemAttachmentAudio },
  props: {
    message: { type: Object as () => Message, required: true },
    available: { type: Boolean, required: true },
    isAuthor: { type: Boolean, required: true },
    price: { type: String, required: true },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
    isAudio: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onUnlock = () => {
      if (
        props.message.attachment.every((attachment: MessageAttachment) => attachment.file.processingStatus !== "ERROR")
      ) {
        emit("click");
        return;
      }
    };

    return {
      onUnlock,
    };
  },
});
